import { FC } from 'react';
import { Outlet } from 'react-router-dom';

export const ReportsGrainPage: FC = () => {
  return <Outlet />;
};
